import React, { Component } from 'react';
import { objectOf, func, string, number, shape, bool } from 'prop-types';
import styles from './styles.scss';
import cx from 'classnames';
import { newAdUsersKey } from '../../../../helpers/constant';

export default class WebTableRow extends Component {
  static propTypes = {
    onCellClick: func,
    data: objectOf(shape({
      time: string,
      visit: number,
      // user: number,
      adVisit: number,
      // adUser: number,
      ads: number,
      visitsPerAd: number,
      avgAdCost: number
    })),
    campaignAvgAdCost: number,
    isCustomReport: bool,
    isNewAdUserSelected: bool,
  };

  static defaultProps = {
    data: {}
  };

  render() {
    const { data, onCellClick, campaignAvgAdCost, isCustomReport, isNewAdUserSelected } = this.props;
    // const { time, visit, adVisit, user, adUser, ads, visitsPerAd, avgAdCost } = data;
    const { time, visit, adVisit, ads, visitsPerAd, avgAdCost, newAdUsers, newAdUsersPerAds } = data;
    const formattedAdVisit = parseFloat(adVisit.toFixed(1));
    const formattedNewAdUsers = parseFloat(newAdUsers.toFixed(1));
    const formattedAvgAdCost = avgAdCost == null ? 'N/A' : `$${avgAdCost.toFixed(2).toLocaleString()}`;
    const tableCellClasses = isCustomReport ? cx(styles.tableCell, styles.customTableCell) : styles.tableCell;

    return(
      <div className={styles.tableRow}>
        <div data-test="webTableName" className={tableCellClasses} onClick={onCellClick({data, key: 'time'})}>{time.toLocaleString()}</div>
        <div data-test="webTableVisits" className={tableCellClasses} onClick={onCellClick({data, key: 'visit'})}>{visit.toLocaleString()}</div>
        {/* <div className={styles.tableCell} onClick={onCellClick({data, key: 'user'})}>{user.toLocaleString()}</div> */}
        {isNewAdUserSelected 
          ? <div data-test="webTableNewAdUsers" className={tableCellClasses} onClick={onCellClick({data, key: newAdUsersKey})}>{formattedNewAdUsers.toLocaleString()}</div>
          : <div data-test="webTableAdVisits" className={tableCellClasses} onClick={onCellClick({data, key: 'adVisit'})}>{formattedAdVisit.toLocaleString()}</div>
        }
        {/* <div className={styles.tableCell} onClick={onCellClick({data, key: 'adUser'})}>{adUser.toLocaleString()}</div> */}
        <div data-test="webTableAds" className={tableCellClasses} onClick={onCellClick({data, key: 'ads'})}>{ads.toLocaleString()}</div>
        {isNewAdUserSelected 
         ? <div data-test="webTableNewAdUsersPerAds" className={tableCellClasses} onClick={onCellClick({data, key: 'newAdUsersPerAds'})}>{newAdUsersPerAds.toLocaleString()}</div>
         : <div data-test="webTableAdvisitsAds" className={tableCellClasses} onClick={onCellClick({data, key: 'visitsPerAd'})}>{visitsPerAd.toLocaleString()}</div>
        }
        {campaignAvgAdCost != null && <div data-test="webTableAvgAdCost" className={tableCellClasses} onClick={onCellClick({data, key: 'avgAdCost'})}>{formattedAvgAdCost}</div>}
      </div>
    )
  }
}